import Vue from 'vue'
import Router from 'vue-router'
import Vuex from 'vuex'
import store from '../store'

// COMPONENTS
import LaunchPage from '@/components/LaunchPage'
import PageNotFound from '@/components/PageNotFound'
import PageForbidden from '@/components/PageForbidden'
import LoginPage from '@/components/LoginPage'
import LogoutPage from '@/components/LogoutPage'
import CollectiveFrame from '@/components/Collective/CollectiveFrame'
import CollectiveGallery from '@/components/Collective/CollectiveGallery'
import CollectiveMembers from '@/components/Collective/CollectiveMembers'
import CollectiveServices from '@/components/Collective/CollectiveServices'
import AdminFrame from '@/components/Admin/AdminFrame'
import EmptyFrame from '@/components/Admin/EmptyFrame'
import OnboardingFrame from '@/components/Onboarding/OnboardingFrame'
import DashboardFrame from '@/components/Dashboard/DashboardFrame'

// Admin Panel
import AdminDashboard from '@/components/Admin/General/AdminDashboard'
import AdminFollowers from '@/components/Admin/General/AdminFollowers'
import AdminSupport from '@/components/Admin/General/AdminSupport'
import AdminImageDrive from '@/components/Admin/General/AdminImageDrive'
import AdminServices from '@/components/Admin/General/AdminServices'
import AdminUpload from '@/components/Admin/General/AdminUpload'
import AdminSettingsGeneral from '@/components/Admin/Settings/AdminSettingsGeneral'
import AdminSettingsMembers from '@/components/Admin/Settings/AdminSettingsMembers'
import AdminSettingsPolicies from '@/components/Admin/Settings/AdminSettingsPolicies'

Vue.use(Router)
Vue.use(Vuex)

export default new Router({
  mode: 'history',
  routes: [
    { // Login path - /login
      path: '/login',
      name: 'Login',
      component: LoginPage
    },
    {
      path: '/logout',
      name: 'Logout',
      component: LogoutPage
    },
    {
      path: '/onboarding',
      name: 'Onboarding',
      component: OnboardingFrame
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: DashboardFrame,
      beforeEnter: (to, from, next) => {
        Vue.prototype.$firebase.auth().onAuthStateChanged((u) => {
          if (u) {
            next()
          } else {
            next('/forbidden')
          }
        })
      }
    },
    { // Admin Routes - /admin
      path: '/admin/:slug/',
      props: true,
      component: EmptyFrame,
      beforeEnter: (to, from, next) => {
        Vue.prototype.$firebase.auth().onAuthStateChanged((u) => {
          if (u) {
            store.dispatch('fetchCollective', to.params.slug).then((result) => {
              if (result) next()
              else next('/404')
            })
          } else {
            next('/forbidden')
          }
        })
      },
      children: [
        {
          path: 'd',
          component: AdminFrame,
          props: true,
          children: [
            { path: 'upload', name: 'AdminUpload', component: AdminUpload },
            { path: 'dashboard', name: 'AdminDashboard', component: AdminDashboard },
            { path: 'images', name: 'AdminImageDrive', component: AdminImageDrive },
            { path: 'services', name: 'AdminServices', component: AdminServices },
            { path: 'followers', name: 'AdminFollowers', component: AdminFollowers },
            { path: 'widgets', name: 'AdminSupport', component: AdminSupport },
            { path: 'general', name: 'AdminSettingsGeneral', component: AdminSettingsGeneral },
            { path: 'members', name: 'AdminSettingsMembers', component: AdminSettingsMembers },
            { path: 'policies', name: 'AdminSettingsPolicies', component: AdminSettingsPolicies },
            { path: '', redirect: 'dashboard' }
          ]
        },
        { path: '', redirect: 'd' }
      ]
    },
    { // Collective Routes - /@
      path: '/@/:slug/',
      component: CollectiveFrame,
      props: true,
      children: [
        {
          path: 'gallery',
          component: CollectiveGallery,
          children: [
            { path: 'page/:pageNum', component: CollectiveGallery, props: true }
          ]
        },
        { path: 'members', component: CollectiveMembers },
        { path: 'services', component: CollectiveServices },
        { path: '', redirect: 'gallery' }
      ]
    },
    { // Home Page - /
      path: '/',
      name: 'Launch',
      component: LaunchPage
    },
    {
      path: '/forbidden',
      name: 'Forbidden',
      component: PageForbidden
    },
    { // 404 Route - **
      path: '*',
      component: PageNotFound
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/router.js